import { Tabs } from "flowbite";

const SubmissionTabs = () => {

  const tabsElement = document.getElementById("tabs-example");

  if(!tabsElement){
    return;
  }

  const tabElements = [
    {
      id: "form",
      triggerEl: document.querySelector("#form-tab"),
      targetEl: document.querySelector("#form"),
    },
    {
      id: "difference",
      triggerEl: document.querySelector("#difference-tab"),
      targetEl: document.querySelector("#difference"),
    },
    {
      id: "progression",
      triggerEl: document.querySelector("#progression-tab"),
      targetEl: document.querySelector("#progression"),
    },
    {
      id: "notes",
      triggerEl: document.querySelector("#notes-tab"),
      targetEl: document.querySelector("#notes"),
    },
  ];

  // options with default values
  const options = {
    defaultTabId: "form",
    activeClasses: "!bg-kensa_lime !text-black !border-kensa_lime",
    inactiveClasses: "text-white"
  };

  // instance options with default values
  const instanceOptions = { id: "tabs-example", override: true };

  // Create a new Tab instance
  window.tabs = new Tabs(tabsElement, tabElements, options, instanceOptions);

  // Function to get the value of a query parameter from the URL
  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Get the value of the 'tab' query parameter
  const activeTabId = getQueryParam("tab");

  // If a 'tab' parameter exists in the URL, activate the corresponding tab
  if (activeTabId) {
    const tabToActivate = tabElements.find((tab) => tab.id === activeTabId);
    if (tabToActivate) {
    window.tabs.show(tabToActivate.id);
    }
  }



};

export { SubmissionTabs };
